import { render, staticRenderFns } from "./safetyCheck.vue?vue&type=template&id=cf0feaf8"
import script from "./safetyCheck.vue?vue&type=script&lang=js"
export * from "./safetyCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf0feaf8')) {
      api.createRecord('cf0feaf8', component.options)
    } else {
      api.reload('cf0feaf8', component.options)
    }
    module.hot.accept("./safetyCheck.vue?vue&type=template&id=cf0feaf8", function () {
      api.rerender('cf0feaf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/smd/safetyCheck.vue"
export default component.exports